import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="vacation-patterns--form"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.updateBreadcrumb();
  }

  updateBreadcrumb() {
    const name = this.formTarget.querySelector(`input[name$="[name]"]`).value;
    const breadcrumbText = `${name}`;

    document.querySelector(".master-page .crumb").innerHTML = `マスタ ＞ 勤怠区分マスタ ＞ ${breadcrumbText}`;
  }
}
